import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 8.125a.875.875 0 0 0-.875.875v5.1a.875.875 0 1 0 1.75 0V11a.875.875 0 0 0-.875-.875ZM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      clip-rule="evenodd"
    />
  </svg>
`;
